
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'app-textarea',
})
export default class AppTextarea extends Vue {
  @Prop({ required: true, type: String })
  readonly value!: string;

  @Prop({ required: false, type: String })
  readonly placeholder?: string;

  @Prop({ required: false, type: String, default: '3' })
  readonly rows?: string;

  get rowsHeight(): string {
    // Calculate minimum height based on rows (approximate line height of 1.5em)
    return this.rows ? `${parseInt(this.rows) * 1.5}em` : 'auto';
  }

  focus(options?: FocusOptions) {
    (this.$el as HTMLDivElement).focus(options);
  }

  @Watch('value')
  onValueChange(val: string) {
    if (document.activeElement?.isSameNode(this.$el)) return;
    (this.$el as HTMLDivElement).innerText = val;
  }
}
